import { useState } from 'react';
import { requestPasswordReset } from '../api';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await requestPasswordReset(email);
      setSubmitted(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.title}>100 Club</h1>
        <h2 style={styles.subtitle}>Reset Password</h2>

        {submitted ? (
          <div style={styles.successBox}>
            <p>If that email address is registered, you'll receive a password reset link shortly.</p>
            <p>Check your inbox and spam folder.</p>
            <a href="/" style={styles.link}>Back to Login</a>
          </div>
        ) : (
          <>
            {error && <div style={styles.error}>{error}</div>}
            <p style={styles.instructions}>
              Enter your email address and we'll send you a link to reset your password.
            </p>
            <form onSubmit={handleSubmit}>
              <div style={styles.field}>
                <label style={styles.label}>Email</label>
                <input
                  style={styles.input}
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <button style={styles.button} type="submit" disabled={loading}>
                {loading ? 'Sending...' : 'Send Reset Link'}
              </button>
            </form>
            <p style={styles.backText}>
              <a href="/" style={styles.link}>Back to Login</a>
            </p>
          </>
        )}
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f0f4f8'
  },
  card: {
    backgroundColor: 'white',
    padding: '40px',
    borderRadius: '12px',
    boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
    width: '100%',
    maxWidth: '400px'
  },
  title: {
    textAlign: 'center',
    color: '#3e5859',
    marginBottom: '4px',
    fontSize: '32px'
  },
  subtitle: {
    textAlign: 'center',
    color: '#4a5568',
    marginBottom: '24px',
    fontWeight: 'normal',
    fontSize: '18px'
  },
  instructions: {
    color: '#4a5568',
    fontSize: '14px',
    marginBottom: '20px'
  },
  error: {
    backgroundColor: '#fed7d7',
    color: '#c53030',
    padding: '10px',
    borderRadius: '6px',
    marginBottom: '16px',
    fontSize: '14px'
  },
  successBox: {
    backgroundColor: '#c6f6d5',
    color: '#276749',
    padding: '16px',
    borderRadius: '6px',
    fontSize: '14px',
    lineHeight: '1.6'
  },
  field: { marginBottom: '16px' },
  label: {
    display: 'block',
    marginBottom: '6px',
    color: '#4a5568',
    fontSize: '14px',
    fontWeight: '500'
  },
  input: {
    width: '100%',
    padding: '10px',
    borderRadius: '6px',
    border: '1px solid #e2e8f0',
    fontSize: '16px',
    boxSizing: 'border-box'
  },
  button: {
    width: '100%',
    padding: '12px',
    backgroundColor: '#3e5859',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    fontSize: '16px',
    cursor: 'pointer',
    marginTop: '8px'
  },
  backText: {
    textAlign: 'center',
    marginTop: '20px',
    fontSize: '14px'
  },
  link: {
    color: '#3e5859',
    fontWeight: '500'
  }
};